import React from 'react';

import { Box, Fab, styled } from '@mui/material';

import { ArrowBack, ArrowForward } from '@mui/icons-material';

import PropTypes from 'prop-types';

import { useSwiper } from 'swiper/react';

const FabCus = styled(Fab)(() => ({
  boxShadow: 'none',
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  '&:active': { boxShadow: 'none' },
}));

const CustomNavigation = ({ slidesCount }) => {
  const swiper = useSwiper();
  if (slidesCount > swiper.params.slidesPerView)
    return (
      <Box slot='wrapper-end'>
        <FabCus onClick={() => swiper.slidePrev()} style={{ left: 0 }}>
          <ArrowBack />
        </FabCus>
        <FabCus onClick={() => swiper.slideNext()} style={{ right: 0 }}>
          <ArrowForward />
        </FabCus>
      </Box>
    );
};

CustomNavigation.propTypes = {
  slidesCount: PropTypes.number,
};

export default CustomNavigation;
